import { render, staticRenderFns } from "./ThankyouPageTab.vue?vue&type=template&id=0f593a09"
import script from "./ThankyouPageTab.vue?vue&type=script&lang=js"
export * from "./ThankyouPageTab.vue?vue&type=script&lang=js"
import style0 from "./ThankyouPageTab.vue?vue&type=style&index=0&id=0f593a09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports